// @flow
import NotFoundLoader from './404Loader';
export default NotFoundLoader;
